import { render, staticRenderFns } from "./StatoInput.vue?vue&type=template&id=1c0e782e&scoped=true"
import script from "./StatoInput.vue?vue&type=script&lang=js"
export * from "./StatoInput.vue?vue&type=script&lang=js"
import style0 from "./StatoInput.vue?vue&type=style&index=0&id=1c0e782e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e782e",
  null
  
)

export default component.exports